import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const ticket_endpoints = APIS_ENDPOINTS.ticket

export interface ITicketMessagePayload {
  TicketId?: number
  Text: string
  TicketFiles?: File[]
}
export const request_adminanswer = async ({Text, TicketFiles, TicketId}: ITicketMessagePayload) => {
  const formData = new FormData()
  formData.append('Text', Text)
  formData.append('TicketId', TicketId?.toString() || '')
  if (TicketFiles && TicketFiles.length > 0) {
    for (let i = 0; i < TicketFiles.length; i++) {
      if (TicketFiles?.[i]) {
        formData.append('TicketFiles', TicketFiles[i])
      }
    }
  }

  return http.post(ticket_endpoints.adminanswer, formData)
}

export const request_getTickets = async ({
  search,
  CurrentPage,
  PageSize,
  Priority,
  IsMe,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
  Priority: number
  IsMe: boolean
}) => {
  return http.get(
    ticket_endpoints.datatable +
      `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}${
        Priority !== undefined ? `&Priority=${Priority}` : ''
      }${IsMe !== undefined ? `&IsMe=${IsMe}` : ''}`
  )
}

export const request_getDetail = async (id: number) => {
  return http.get(ticket_endpoints.detail + `?id=${id}`)
}

export const request_changeticketstatus = async ({
  status,
  ticketId,
}: {
  ticketId?: number
  status?: number
}) => {
  return http.put(ticket_endpoints.changeticketstatus, {
    status,
    ticketId,
  })
}
